package pt.at.oss.kotlin.pages.i18n

import pt.at.oss.kotlin.core.i18n.I18nBase
import pt.at.oss.kotlin.core.i18n.PageLocale

/**
 *  Translations for shared Registo translations.
 */
enum class RegistoSharedI18n(override val translations: Map<PageLocale, String>) : I18nBase {

    NETP_VIGENTE_LABEL(mapOf(PageLocale.PT to "Vigente")),
    NETP_NOT_VIGENTE_LABEL(mapOf(PageLocale.PT to "Não Vigente")),
    ;
}
